import type { ReactNode } from "react";
import type { PortableTextComponents } from "@portabletext/react";
import { measuredRichTextDark, measuredRichTextForest } from "@/components/pageComponents/patrickAffiliate/richtext";

export const noWidow = (text?: string) =>
  text && text.trim().split(/ +/).length > 2 ? text.replace(/ ([^ ]+)$/, "\u00A0$1") : text;

function lastWordsTogether(children: ReactNode): ReactNode {
  if (typeof children === "string") return noWidow(children);
  if (Array.isArray(children) && typeof children[children.length - 1] === "string") {
    return [...children.slice(0, -1), noWidow(children[children.length - 1])];
  }
  return children;
}

const withoutWidows = (components: PortableTextComponents): PortableTextComponents => ({
  ...components,
  block: {
    ...(typeof components.block === "object" ? components.block : {}),
    normal: ({ children }) => <p className="p-normal">{lastWordsTogether(children)}</p>,
  },
});

export const competitorRichText = withoutWidows(measuredRichTextForest);
export const competitorRichTextDark = withoutWidows(measuredRichTextDark);
